await window.dshell.init();
export const shell = window.dshell;
export const fetch = window.edgeFetch;
